import { h } from "preact";
import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import palette from "./palette";

// The `withStyles()` higher-order component is injecting a `classes`
// prop that is used by the `Button` component.
const NavSecondaryButtonMk2 = withStyles({
  root: {
    color: palette.lightblack,
    padding: "0px 10px",
    marginRight: "20px",
    "&:hover": {
      borderRadius: "24px",
      height: "48px",
      marginTop: "10px",
      marginBottom: "10px",
      // alignItems: "center"
    },
  },
  label: {
    textTransform: "none",
  },
})(Button);

export default NavSecondaryButtonMk2;
